const state = {
    CustomFieldFilter: "",
    CustomFieldFilterChip: "",
    Header: []
};

const mutations = {
    SET_TABLE_FILTER: (state, info) => {
        state.CustomFieldFilter = info;
    },
    SET_FILTER_CHIP: (state, info) => {
        state.CustomFieldFilterChip = info;
    },
    SET_CUSTOM_FIELD_HEADER: (state, info) => {
        state.Header = JSON.parse(JSON.stringify(info));
    }
};

const actions = {
    setTableFilter({ commit, dispatch }, info) {
        if (info) {
            commit("SET_TABLE_FILTER", info);
        }
        else {
            commit("SET_TABLE_FILTER", info);
            dispatch("setFilterChip", "");
        }
    },
    setFilterChip({ commit, dispatch }, info) {
        commit("SET_FILTER_CHIP", info);
    },
    removeCustomFieldFilter({ state, commit, dispatch }, info) {
        console.log("info", info);
        console.log("state.CustomFieldFilterChip", state.CustomFieldFilterChip);
        console.log("state.Header", state.Header);
        var index = state.CustomFieldFilterChip.indexOf(info);
        var filterChipCp = [...state.CustomFieldFilterChip];
        filterChipCp.splice(index, 1);

        state.Header.forEach(header => {
            if (header.columnKey == info.id) {
                let arrIndex = header.filtered.indexOf(info.value);
                header.filtered.splice(arrIndex, 1);
            }
        });

        dispatch("formatCustomField", state.Header);
        dispatch("setFilterChip", filterChipCp);
    },
    arrangeCustomFieldFilter({ dispatch }, data_query) {
        var formattedQuery = data_query.substring(0, data_query.length - 4);
        console.log("formattedQuery", formattedQuery);
        dispatch("setTableFilter", formattedQuery);
    },
    async updateQuery({ dispatch }, customFieldHeaders) {
        await customFieldHeaders.forEach(header => {
            var custom_filed_id = header.columnKey.replace(/EXTENSION_DATA_/g, "");
            var filter_query = "";
            if (header.filtered) {
                header.filtered.forEach(e => {
                    filter_query = filter_query + `[${custom_filed_id}] = '${e}' OR `;
                });
            }

            var formatted_query = filter_query.substring(0, filter_query.length - 4);
            header.query = formatted_query;
            console.log("formatted_query", formatted_query);
        });

        var data_query = "";
        await customFieldHeaders.forEach(header => {
            if (header.query) {
                data_query = `${data_query}(${header.query}) AND `;
            }
        });

        dispatch("arrangeCustomFieldFilter", data_query);
    },
    async formatCustomField({ commit, dispatch }, customFieldHeaders) {
        console.log("customFieldHeaders", customFieldHeaders);
        var displayChip = [];
        await customFieldHeaders.forEach(header => {
            // Search
            if (header.searched) {
                let search_value = header.searched;
                displayChip.push({ id: header.columnKey, "name": header.label, "value": search_value, "inputTypeCode": header.inputTypeCode, "type": "search" });
            }

            // Display Chip
            header.filtered.forEach(filter => {
                if (filter) {
                    displayChip.push({ id: header.columnKey, "name": header.label, "value": filter, "inputTypeCode": header.inputTypeCode, "type": "filter" });
                }
            });
        });

        dispatch("updateQuery", customFieldHeaders);
        dispatch("setFilterChip", displayChip);
        commit("SET_CUSTOM_FIELD_HEADER", customFieldHeaders);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/vuex/modules/table_filter.js